import { render } from "./Download.vue?vue&type=template&id=746b9746"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"
script.render = render

export default script